import { FormattedMessage } from 'react-intl'

import { cn } from '@/lib/utils'
import {
  Avatar,
  Select,
  SelectAnimatedPlaceholder,
  SelectContent,
  SelectItem,
  SelectTrigger,
  Typography,
} from '@/shared/ui'

import { EntityType } from '../features/Recipients/types'
import { getIconByEntityType } from '../features/Recipients/utils'

type Props = {
  disabled?: boolean
  value?: string
  onChange: (v: string) => void
}

export const RecipientTypeSelect = ({ disabled, onChange, value }: Props) => {
  const SelectedIcon = getIconByEntityType(value as EntityType)

  return (
    <Select onValueChange={onChange} value={value}>
      <SelectTrigger disabled={disabled}>
        <SelectAnimatedPlaceholder
          disabled={disabled}
          selectedComponent={
            <div className="mt-0.5 flex items-center gap-1">
              {disabled ? null : (
                <Avatar
                  shape="square"
                  icon={
                    <SelectedIcon className="text-neutral-gray-900 size-3" />
                  }
                  size="sm"
                />
              )}

              <Typography
                className={cn(
                  'text-neutral-gray-900',
                  disabled && 'text-neutral-gray-600',
                )}
              >
                <FormattedMessage
                  defaultMessage="{entity, select, BUSINESS {Business} INDIVIDUAL {Individual} other {}}"
                  id="recipients.entity"
                  values={{ entity: value }}
                />
              </Typography>
            </div>
          }
          placeholder={
            <FormattedMessage
              id="label.recipientType"
              defaultMessage="Recipient type"
            />
          }
          value={value}
        />
      </SelectTrigger>

      <SelectContent>
        {Object.values(EntityType).map((type) => {
          const Icon = getIconByEntityType(type)

          return (
            <SelectItem
              disabled={type === value}
              hideChecked
              className="flex h-[54px] items-center gap-3"
              key={type}
              value={type}
            >
              <Avatar
                shape="square"
                variant="dark-neutral"
                icon={<Icon className="size-4" />}
                size="md"
              />

              <Typography>
                <FormattedMessage
                  defaultMessage="{entity, select, BUSINESS {Business} INDIVIDUAL {Individual} other {}}"
                  id="recipients.entity"
                  values={{ entity: type }}
                />
              </Typography>
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}
